import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from '../../hooks/useTranslation';
import hero1 from '../../assets/images/heroback.png';

export default function Hero() {
  const { t } = useTranslation();
  const heroImages = [hero1];

  return (
    <section className="relative overflow-hidden h-screen">
      {/* Фоновое изображение */}
      <div className="absolute inset-0">
        <motion.div
          className="absolute inset-0"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.5, ease: "easeInOut" }}
        >
          <img
            src={heroImages[0]}
            alt="Hero background"
            className="w-full h-full object-cover"
          />
          {/* Темный оверлей для лучшей читаемости текста */}
          <div className="absolute inset-0 bg-black/40"></div>
        </motion.div>
      </div>

      {/* Мобильная фоновая фотография */}
      <div className="absolute inset-0 lg:hidden">
        <motion.div
          className="absolute inset-0"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.5, ease: "easeInOut" }}
        >
          <img
            src="/images/me/F3.jpg"
            alt="Альфира Херрманн - фон"
            className="w-full h-full object-cover object-center"
          />
          {/* Темный оверлей для лучшей читаемости текста */}
          <div className="absolute inset-0 bg-black/50"></div>
        </motion.div>
      </div>

      {/* Декоративные элементы */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-white rounded-full mix-blend-multiply filter blur-xl opacity-10 animate-float"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gray-300 rounded-full mix-blend-multiply filter blur-xl opacity-10 animate-float" style={{animationDelay: '2s'}}></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-60 h-60 bg-white rounded-full mix-blend-multiply filter blur-xl opacity-5 animate-float" style={{animationDelay: '4s'}}></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 h-full flex items-center justify-center pt-12 sm:pt-16">
        {/* Мобильная версия - полная ширина */}
        <div className="w-full lg:hidden">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, ease: "easeOut" }}
            className="space-y-6 text-center px-4"
          >
            <h1 className="font-playfair text-4xl sm:text-5xl font-bold leading-tight text-white drop-shadow-2xl">
              <span className="block italic font-light">
                {t('hero.name_first')}
              </span>
              <span className="block italic font-light">
                {t('hero.name_last')}
              </span>
            </h1>
            
            <div className="font-playfair text-lg sm:text-xl md:text-2xl text-white leading-relaxed drop-shadow-lg mt-8">
              <p className="mb-4 font-light">{t('hero.subtitle')}</p>
              {t('hero.description').split('\n\n').map((line, index) => (
                <p key={index} className="text-rose-200 font-light italic mb-3">{line}</p>
              ))}
            </div>
            
            <div className="pt-4 flex justify-center">
              <div className="w-24 h-1 bg-gradient-to-r from-white to-transparent rounded-full"></div>
            </div>
          </motion.div>
        </div>

        {/* Десктопная версия */}
        <div className="hidden lg:flex w-full">
          {/* Левая часть - пустая */}
          <div className="w-1/3"></div>
          
          {/* Правая часть - текст */}
          <div className="w-2/3 pr-4">
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1.2, ease: "easeOut" }}
              className="space-y-6"
            >
              <h1 className="font-playfair text-7xl xl:text-8xl 2xl:text-9xl font-bold leading-tight text-white drop-shadow-2xl">
                <span className="block italic font-light">
                  {t('hero.name_first')}
                </span>
                <span className="block italic font-light">
                  {t('hero.name_last')}
                </span>
              </h1>
              
              <div className="font-playfair text-4xl xl:text-5xl 2xl:text-6xl text-white leading-relaxed drop-shadow-lg max-w-4xl mt-12">
                <p className="mb-4 font-light">{t('hero.subtitle')}</p>
                {t('hero.description').split('\n\n').map((line, index) => (
                  <p key={index} className="text-rose-200 font-light italic mb-6">{line}</p>
                ))}
              </div>
              
              <div className="pt-4">
                <div className="w-24 h-1 bg-gradient-to-r from-white to-transparent rounded-full"></div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>


    </section>
  );
}
